var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.223 3.416l8.539.004c.565 0 1.027.453 1.038 1.018.011.54-.417.985-.956.997h-.04L.58 5.265c-.544-.01-1.007-.4-1.112-.934-.081-.416.19-.819.606-.9.049-.01.098-.015.148-.015z",
    transform: "translate(-40.000000, -405.000000) translate(30.069767, 398.000000) translate(9.930233, 7.000000) translate(4.555653, 4.435628) rotate(-45.000000) translate(-4.555653, -4.435628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.273 9.557l8.474-.11c.543-.007.99.427.996.97v.034c-.012.567-.47 1.024-1.038 1.033l-8.436.132c-.56.009-1.02-.438-1.029-.997V10.6c.001-.572.461-1.037 1.033-1.044z",
    transform: "translate(-40.000000, -405.000000) translate(30.069767, 398.000000) translate(9.930233, 7.000000) translate(4.501274, 10.532918) rotate(45.000000) translate(-4.501274, -10.532918)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.98b19958928ebdae7f114c93a8033ec0.svg";
export { ForwardRef as ReactComponent };